import React from "react";

type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  variant?: "primary" | "ghost";
  type?: "button" | "submit" | "reset";
};

const Button = ({
  children,
  className = "",
  onClick,
  variant = "primary",
  type = "button",
}: ButtonProps) => {
  const baseClasses =
    "tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-rbah tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-transition";
  const variantClasses =
    variant === "primary"
      ? "tw-bg-rbah-ink tw-text-rbah-off hover:tw-bg-rbah-deep"
      : "tw-border tw-border-rbah-ink/20 tw-bg-white tw-text-rbah-ink hover:tw-bg-rbah-off";

  return (
    <button
      type={type}
      onClick={onClick}
      className={`${baseClasses} ${variantClasses} ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
